// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientProfessionalTeam_ProfessionalTeamRoleFragment = { __typename?: 'ProfessionalTeamRole', id: string, kind: Types.ProfessionalTeamRoleKind, otherRoleName?: string | null, powerOfAttorneyKind?: Types.ProfessionalTeamRolePowerOfAttorneyKind | null, household: { __typename?: 'Household', id: string }, associatedClientIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string, legalName: string } | null };

export type ClientProfessionalTeam_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, legalName: string, professionalTeamRoles: { __typename?: 'ProfessionalTeamRoleConnection', edges?: Array<{ __typename?: 'ProfessionalTeamRoleEdge', node?: (
        { __typename?: 'ProfessionalTeamRole' }
        & ClientProfessionalTeam_ProfessionalTeamRoleFragment
      ) | null } | null> | null } };

export type ClientProfessionalTeam_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, kind?: Types.ClientOrganizationKind | null, name: string, professionalTeamRoles: { __typename?: 'ProfessionalTeamRoleConnection', edges?: Array<{ __typename?: 'ProfessionalTeamRoleEdge', node?: (
        { __typename?: 'ProfessionalTeamRole' }
        & ClientProfessionalTeam_ProfessionalTeamRoleFragment
      ) | null } | null> | null } };

export type ClientProfessionalTeamQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ClientProfessionalTeamQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, principalClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> } | null } | null> | null }, clientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & ClientProfessionalTeam_ClientProfileFragment
      ) | null } | null> | null }, clientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: (
        { __typename?: 'ClientOrganization' }
        & ClientProfessionalTeam_ClientOrganizationFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ClientProfessionalTeam: 'ClientProfessionalTeam' as const
  },
  Fragment: {
    ClientProfessionalTeam_ProfessionalTeamRole: 'ClientProfessionalTeam_ProfessionalTeamRole' as const,
    ClientProfessionalTeam_ClientProfile: 'ClientProfessionalTeam_ClientProfile' as const,
    ClientProfessionalTeam_ClientOrganization: 'ClientProfessionalTeam_ClientOrganization' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientProfessionalTeam_ProfessionalTeamRoleFragmentDoc = gql`
    fragment ClientProfessionalTeam_ProfessionalTeamRole on ProfessionalTeamRole {
  id
  kind
  otherRoleName
  powerOfAttorneyKind
  household {
    id
  }
  associatedClientIndividual {
    id
    displayName
    legalName
  }
}
    `;
export const ClientProfessionalTeam_ClientProfileFragmentDoc = gql`
    fragment ClientProfessionalTeam_ClientProfile on ClientProfile {
  id
  displayName
  legalName
  professionalTeamRoles {
    edges {
      node {
        ...ClientProfessionalTeam_ProfessionalTeamRole
      }
    }
  }
}
    ${ClientProfessionalTeam_ProfessionalTeamRoleFragmentDoc}`;
export const ClientProfessionalTeam_ClientOrganizationFragmentDoc = gql`
    fragment ClientProfessionalTeam_ClientOrganization on ClientOrganization {
  id
  kind
  name
  professionalTeamRoles {
    edges {
      node {
        ...ClientProfessionalTeam_ProfessionalTeamRole
      }
    }
  }
}
    ${ClientProfessionalTeam_ProfessionalTeamRoleFragmentDoc}`;
export const ClientProfessionalTeamDocument = gql`
    query ClientProfessionalTeam($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        principalClients: possiblePrimaryClients {
          id
          displayName
        }
      }
    }
  }
  clientProfiles(where: {and: [{hasHouseholdWith: {id: $householdId}}]}) {
    edges {
      node {
        ...ClientProfessionalTeam_ClientProfile
      }
    }
  }
  clientOrganizations(where: {and: [{hasHouseholdWith: {id: $householdId}}]}) {
    edges {
      node {
        ...ClientProfessionalTeam_ClientOrganization
      }
    }
  }
}
    ${ClientProfessionalTeam_ClientProfileFragmentDoc}
${ClientProfessionalTeam_ClientOrganizationFragmentDoc}`;

/**
 * __useClientProfessionalTeamQuery__
 *
 * To run a query within a React component, call `useClientProfessionalTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfessionalTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfessionalTeamQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useClientProfessionalTeamQuery(baseOptions: Apollo.QueryHookOptions<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>(ClientProfessionalTeamDocument, withFetchPolicyContext(options));
      }
export function useClientProfessionalTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>(ClientProfessionalTeamDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientProfessionalTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>(ClientProfessionalTeamDocument, withFetchPolicyContext(options));
        }
export type ClientProfessionalTeamQueryHookResult = ReturnType<typeof useClientProfessionalTeamQuery>;
export type ClientProfessionalTeamLazyQueryHookResult = ReturnType<typeof useClientProfessionalTeamLazyQuery>;
export type ClientProfessionalTeamSuspenseQueryHookResult = ReturnType<typeof useClientProfessionalTeamSuspenseQuery>;
export type ClientProfessionalTeamQueryResult = Apollo.QueryResult<ClientProfessionalTeamQuery, ClientProfessionalTeamQueryVariables>;